<template>
  <div class="books-details">
    <!-- 顶部大图片 -->
    <!-- <imgBigCards></imgBigCards> -->
    <!-- 标题-->

    <!-- 内容 -->
    <div class="content-box">
      <!-- ---------------- -->
      <p>
        网店名称： <span>{{ mydata.onlineStoreObj.shop_name }}</span>
      </p>
      <p>
        网址：<span>{{ mydata.onlineStoreObj.shop_url }}</span>
      </p>
      <p>
        授权代码：<span>{{ mydata.onlineStoreObj.certificate_number }}</span>
      </p>
      <p>
        授权时间：<span>{{
            dayjs(mydata.onlineStoreObj.create_time * 1000).format("YYYY-MM-DD")
          }}</span>
      </p>
      <p>
        地区：<span>{{ mydata.onlineStoreObj.province }}</span>
      </p>
      <p>
        平台：<span>{{ mydata.onlineStoreObj.shop_platform_text }}</span>
      </p>
      <p>
        有效期：<span
          >{{
            dayjs(mydata.onlineStoreObj.start_time * 1000).format("YYYY-MM-DD")
          }}
          至
          {{
            dayjs(mydata.onlineStoreObj.end_time * 1000).format("YYYY-MM-DD")
          }}</span
        >
      </p>
      <!-- ---------------- -->
      <div class="details-certificate">
        <img v-complete:src="mydata.onlineStoreObj.certificate_path" alt="" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { useRouter, useRoute } from "vue-router";

import { reactive, computed } from "vue";

import dayjs from "dayjs";

//网店详情
import { onlineStoreInfo } from "@/api/distributionAuthorization/authorizedOnlineShop/index.js";

const router = useRouter();
const route = useRoute();

const mydata = reactive({
  size: "default",
  onlineStoreId: null, //店铺id值
  onlineStoreObj: {}, //网店详情
  // 基础地址
  VUE_APP_BASE_HOST: process.env.VUE_APP_BASE_HOST,
});

// //点击事件
// function submitQualificationsStep1Button() {
//   router.push({
//     path: "/layout/list/progressStep1",
//   });
// }

//网店详情
function fn() {
  // 获取到传递过来的参数
  mydata.onlineStoreId = route.query.id;

  onlineStoreInfo({ id: mydata.onlineStoreId }).then((res) => {
    // console.log(res.data, "网店详情");
    mydata.onlineStoreObj = res.data;
    // 设置title标题
    window.document.getElementsByTagName("title")[0].innerHTML =
      mydata.onlineStoreObj.shop_name;
  });
}

fn();
</script>

<style scoped lang="scss">
.books-details {
  background-color: #f9f9f9;
  overflow: hidden;
  // border: 1px solid red;
  padding-bottom: 40px; //距离bottomBar的距离

 

  //////内容
  .content-box {
    width: 375px;
    // height: 720px;
    margin: 0 auto;
    margin-top:16px;
    padding: 16px;
    // border: 1px solid red;
    background-color: #ffffff;

   
    
    ////////////////
    >p{
      font-size:14px;
      font-weight:700;
      letter-spacing: 1px;
      color:#333333;
      line-height:22px;
      margin-bottom:12px;
      span{
        color:#000000A6;
        font-weight:400;
        letter-spacing: 0px;
      }

    }


    ////////////////授权证书
    .details-certificate {
      width: 100%;
      // height:435px;
      margin-top: 24px;
      border: 1px solid #dcdee2;
      > img {
        width:343px;
        display: flex;
        margin: 0 auto;
      }
    }
  }
}
</style>